export const USER_TYPE = {
  OWNER: 'owner',
  REGULAR: 'regular',
  GUEST: 'guest',
  GUEST_NO_ACCESS: 'guest-no-access'
}
